/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Business_AddressInputs */

const en_label_business_address = /** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Address`)
};

const es_label_business_address = /** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección del Negocio`)
};

const fr_label_business_address = /** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse de l'entreprise`)
};

const de_label_business_address = /** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschäftsadresse`)
};

const id_label_business_address = /** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat Bisnis`)
};

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const ja_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const zh_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const ar_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const it_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const ru_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const pt_label_business_address = en_label_business_address;

/** @type {(inputs: Label_Business_AddressInputs) => LocalizedString} */
const ko_label_business_address = en_label_business_address;

/**
* | output |
* | --- |
* | "Business Address" |
*
* @param {Label_Business_AddressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_business_address = /** @type {((inputs?: Label_Business_AddressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Business_AddressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_business_address(inputs)
	if (locale === "es") return es_label_business_address(inputs)
	if (locale === "fr") return fr_label_business_address(inputs)
	if (locale === "de") return de_label_business_address(inputs)
	if (locale === "ja") return ja_label_business_address(inputs)
	if (locale === "zh") return zh_label_business_address(inputs)
	if (locale === "ar") return ar_label_business_address(inputs)
	if (locale === "id") return id_label_business_address(inputs)
	if (locale === "it") return it_label_business_address(inputs)
	if (locale === "ru") return ru_label_business_address(inputs)
	if (locale === "pt") return pt_label_business_address(inputs)
	return ko_label_business_address(inputs)
});